/* ============================================================
   NUUD cart drawer modules — Rebuy replacement (2026-07).
   Every cart change re-renders the drawer's inner HTML wholesale,
   so all listeners are delegated on document and stateful work
   re-runs through enhance() via a MutationObserver.
   All adds stamp properties._nuud_source for attribution:
   cart-crosssell | cart-protection | cart-upgrade | cart-gift
   ============================================================ */

(function () {
  'use strict';

  var PROTECTION_VARIANT = '47085970358521';
  var EBOOK_VARIANT = '47129549177081';
  var SERVICE_VARIANTS = [PROTECTION_VARIANT, EBOOK_VARIANT];
  var GIFT_DECLINED_KEY = 'nuud_gift_declined';
  var EBOOK_DECLINED_KEY = 'nuud_ebook_declined';
  var PROTECTION_DECLINED_KEY = 'nuud_protection_declined';
  var busy = false;
  var enhancing = false;
  var recCache = new Map();

  /* ---------- cart mutation helper ---------- */

  function mutateCart(url, payload) {
    if (busy) return Promise.resolve(null);
    busy = true;
    var body = Object.assign({}, payload, {
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    });
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (state) {
          if (res.ok && state && state.sections) {
            recCache.clear();
            var drawer = document.querySelector('cart-drawer');
            if (drawer) {
              if (typeof state.item_count === 'number') {
                drawer.classList.toggle('is-empty', state.item_count === 0);
              }
              drawer.renderContents(state);
            }
          }
          return state;
        });
      })
      .catch(function () {
        return null;
      })
      .then(function (state) {
        busy = false;
        return state;
      });
  }

  function addToCart(variantId, source) {
    return mutateCart('/cart/add.js', {
      items: [
        {
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: { _nuud_source: source }
        }
      ]
    });
  }

  function removeFromCart(variantId) {
    return mutateCart('/cart/change.js', { id: String(variantId), quantity: 0 });
  }

  /* ---------- delegated interactions ---------- */

  document.addEventListener('click', function (evt) {
    var recBtn = evt.target.closest('[data-nuud-rec-add]');
    if (recBtn) {
      evt.preventDefault();
      recBtn.disabled = true;
      addToCart(recBtn.dataset.variantId, 'cart-crosssell');
      return;
    }

    var testerBtn = evt.target.closest('[data-nuud-tester-add]');
    if (testerBtn) {
      evt.preventDefault();
      if (busy) return;
      testerBtn.disabled = true;
      // On the /cart page the tile lives outside the drawer, which never
      // re-renders there — add straight and reload so the line list refreshes.
      if (!testerBtn.closest('cart-drawer')) {
        busy = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(testerBtn.dataset.variantId, 10),
                quantity: 1,
                properties: { _nuud_source: 'cart-tester' }
              }
            ]
          })
        })
          .then(function (res) {
            if (res.ok) {
              window.location.reload();
            } else {
              busy = false;
              testerBtn.disabled = false;
            }
          })
          .catch(function () {
            busy = false;
            testerBtn.disabled = false;
          });
      } else {
        addToCart(testerBtn.dataset.variantId, 'cart-tester');
      }
      return;
    }

    var roseBtn = evt.target.closest('[data-nuud-rose-add]');
    if (roseBtn) {
      evt.preventDefault();
      if (busy) return;
      roseBtn.disabled = true;
      // On the /cart page the tile lives outside the drawer, which never
      // re-renders there — add straight and reload so the line list refreshes.
      if (!roseBtn.closest('cart-drawer')) {
        busy = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(roseBtn.dataset.variantId, 10),
                quantity: 1,
                properties: { _nuud_source: 'cart-rose' }
              }
            ]
          })
        })
          .then(function (res) {
            if (res.ok) {
              window.location.reload();
            } else {
              busy = false;
              roseBtn.disabled = false;
            }
          })
          .catch(function () {
            busy = false;
            roseBtn.disabled = false;
          });
      } else {
        addToCart(roseBtn.dataset.variantId, 'cart-rose');
      }
      return;
    }

    var upBtn = evt.target.closest('[data-nuud-upgrade]');
    if (upBtn) {
      evt.preventDefault();
      if (busy) return;
      upBtn.disabled = true;
      var fromId = upBtn.dataset.fromVariant;
      var toId = upBtn.dataset.toVariant;
      // Sequence: drop the single first (no render), then add the 3-pack (renders).
      busy = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: String(fromId), quantity: 0 })
      })
        .catch(function () {})
        .then(function () {
          busy = false;
          return addToCart(toId, 'cart-upgrade');
        });
      return;
    }

    var applyBtn = evt.target.closest('[data-nuud-code-apply]');
    if (applyBtn) {
      evt.preventDefault();
      applyDiscountCode();
      return;
    }

    // Manual gift/ebook removal → don't re-add this session.
    var removeBtn = evt.target.closest('cart-remove-button button[data-variant-id]');
    if (removeBtn) {
      var goal = document.querySelector('[data-nuud-goal]');
      try {
        if (goal && removeBtn.dataset.variantId === goal.dataset.giftVariant) {
          sessionStorage.setItem(GIFT_DECLINED_KEY, '1');
        }
        if (removeBtn.dataset.variantId === EBOOK_VARIANT) {
          sessionStorage.setItem(EBOOK_DECLINED_KEY, '1');
        }
        if (removeBtn.dataset.variantId === PROTECTION_VARIANT) {
          sessionStorage.setItem(PROTECTION_DECLINED_KEY, '1');
        }
      } catch (e) {
        /* private mode */
      }
    }
  });

  document.addEventListener('change', function (evt) {
    var protect = evt.target.closest('[data-nuud-protect]');
    if (!protect) return;
    protect.disabled = true;
    if (protect.checked) {
      // Re-opt-in: forget the earlier decline so auto-add works again.
      try {
        sessionStorage.removeItem(PROTECTION_DECLINED_KEY);
      } catch (e) {
        /* private mode */
      }
      addToCart(protect.dataset.variantId, 'cart-protection');
    } else {
      // Opt-out: remember it so checkProtection() doesn't re-add this session.
      try {
        sessionStorage.setItem(PROTECTION_DECLINED_KEY, '1');
      } catch (e) {
        /* private mode */
      }
      removeFromCart(protect.dataset.variantId);
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Enter' && evt.target.id === 'NuudCartCode') {
      evt.preventDefault();
      applyDiscountCode();
    }
  });

  /* ---------- discount code ---------- */

  function applyDiscountCode() {
    var input = document.getElementById('NuudCartCode');
    var msg = document.querySelector('[data-nuud-code-msg]');
    if (!input || !msg) return;
    var code = input.value.trim();
    if (!code) return;
    msg.hidden = false;
    msg.classList.remove('is-ok');
    msg.textContent = 'Saving your code…';
    // Sets Shopify's discount cookie; validity is confirmed at checkout.
    fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' })
      .then(function () {
        msg.classList.add('is-ok');
        msg.textContent = '✓ ' + code.toUpperCase() + ' will be applied at checkout.';
      })
      .catch(function () {
        msg.textContent = 'We could not save that code here — enter it at checkout.';
      });
  }

  /* ---------- cross-sell (fetches nuud-cart-recs section) ---------- */

  function loadCrossSell(root) {
    var el = root.querySelector('[data-nuud-crosssell]');
    if (!el) return;
    var pid = el.dataset.productId;
    var list = el.querySelector('[data-nuud-crosssell-list]');
    if (!pid || !list) return;
    if (el.dataset.loadedFor === pid) return;

    var render = function (html) {
      // Element may have been re-rendered while fetching — re-query.
      var freshEl = document.querySelector('[data-nuud-crosssell]');
      if (!freshEl || freshEl.dataset.productId !== pid) return;
      var freshList = freshEl.querySelector('[data-nuud-crosssell-list]');
      if (!freshList) return;
      freshList.innerHTML = html;
      freshEl.dataset.loadedFor = pid;
      freshEl.hidden = freshList.querySelectorAll('.nuud-rec').length === 0;
    };

    if (recCache.has(pid)) {
      render(recCache.get(pid));
      return;
    }

    fetch(
      '/recommendations/products?section_id=nuud-cart-recs&product_id=' +
        encodeURIComponent(pid) +
        '&limit=6&intent=related'
    )
      .then(function (res) {
        return res.ok ? res.text() : '';
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var src = doc.querySelector('.nuud-recs-source');
        var html = src ? src.innerHTML : '';
        recCache.set(pid, html);
        render(html);
      })
      .catch(function () {});
  }

  /* ---------- free-gift auto add/remove ---------- */

  function checkGift() {
    if (busy) return;
    var goal = document.querySelector('[data-nuud-goal]');
    if (!goal) return;
    var threshold = parseInt(goal.dataset.giftThreshold, 10);
    var exGift = parseInt(goal.dataset.totalExGift, 10);
    var inCart = goal.dataset.giftInCart === 'true';
    var isAuto = goal.dataset.giftAuto === 'true';
    var declined = false;
    try {
      declined = sessionStorage.getItem(GIFT_DECLINED_KEY) === '1';
    } catch (e) {
      /* private mode */
    }

    if (exGift >= threshold && !inCart && !declined) {
      addToCart(goal.dataset.giftVariant, 'cart-gift');
    } else if (exGift < threshold && inCart && isAuto) {
      removeFromCart(goal.dataset.giftVariant);
    }
  }

  /* ---------- service items (protection, free ebook) ---------- */

  function cartVariantIds() {
    return Array.prototype.map.call(
      document.querySelectorAll('cart-drawer .quantity__input[data-quantity-variant-id]'),
      function (input) {
        return input.dataset.quantityVariantId;
      }
    );
  }

  function hasRealProduct() {
    return cartVariantIds().some(function (id) {
      return SERVICE_VARIANTS.indexOf(id) === -1;
    });
  }

  // If only service items remain (protection / free ebook), clear them out.
  function checkServiceOnly() {
    if (busy) return;
    var ids = cartVariantIds();
    if (ids.length === 0 || hasRealProduct()) return;
    var updates = {};
    ids.forEach(function (id) {
      updates[id] = 0;
    });
    mutateCart('/cart/update.js', { updates: updates });
  }

  // Shipping Protection defaults ON — auto-add it whenever a real product is in
  // the cart and the shopper hasn't opted out this session. Mirrors checkEbook().
  function checkProtection() {
    if (busy) return;
    if (cartVariantIds().indexOf(PROTECTION_VARIANT) !== -1 || !hasRealProduct()) return;
    var declined = false;
    try {
      declined = sessionStorage.getItem(PROTECTION_DECLINED_KEY) === '1';
    } catch (e) {
      /* private mode */
    }
    if (!declined) addToCart(PROTECTION_VARIANT, 'cart-protection');
  }

  // The announcement bar promises the free ebook on every order — make it true.
  function checkEbook() {
    if (busy) return;
    var el = document.querySelector('[data-nuud-ebook]');
    if (!el || el.dataset.inCart === 'true' || !hasRealProduct()) return;
    var declined = false;
    try {
      declined = sessionStorage.getItem(EBOOK_DECLINED_KEY) === '1';
    } catch (e) {
      /* private mode */
    }
    if (!declined) addToCart(el.dataset.variantId, 'cart-ebook');
  }

  /* ---------- honest cutoff timer + delivery estimate ---------- */

  function etNowParts() {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      weekday: 'short',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    });
    var parts = {};
    fmt.formatToParts(new Date()).forEach(function (p) {
      parts[p.type] = p.value;
    });
    return parts;
  }

  function isBusinessDay(dayIdx) {
    return dayIdx >= 1 && dayIdx <= 5; // Mon–Fri
  }

  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (isBusinessDay(d.getUTCDay())) n--;
    }
    return d;
  }

  function fmtDay(date) {
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC'
    }).format(date);
  }

  function updateShipNote() {
    var note = document.querySelector('[data-nuud-ship-note]');
    if (!note) return;

    var p = etNowParts();
    // Anchor "today in ET" at UTC noon so date walking is DST-safe.
    var today = new Date(
      Date.UTC(parseInt(p.year, 10), parseInt(p.month, 10) - 1, parseInt(p.day, 10), 12)
    );
    var hour = parseInt(p.hour, 10) % 24;
    var minute = parseInt(p.minute, 10);
    var isBiz = isBusinessDay(today.getUTCDay());
    var beforeCutoff = isBiz && hour < 18;

    var shipDate = beforeCutoff ? today : addBusinessDays(today, 1);
    var arriveFrom = addBusinessDays(shipDate, 2);
    var arriveTo = addBusinessDays(shipDate, 5);
    var arrives = 'Estimated to arrive ' + fmtDay(arriveFrom) + ' – ' + fmtDay(arriveTo) + '.';

    var lead;
    if (beforeCutoff) {
      var minsLeft = 18 * 60 - (hour * 60 + minute);
      if (minsLeft <= 360) {
        // Countdown only when the cutoff is actually close — a 16h countdown reads as noise.
        var h = Math.floor(minsLeft / 60);
        var m = minsLeft % 60;
        var countdown = (h > 0 ? h + 'h ' : '') + m + 'm';
        lead = 'Order in <b>' + countdown + '</b> and it ships today. ';
      } else {
        lead = 'Order by <b>6pm ET</b> and it ships today. ';
      }
    } else {
      lead = 'Ships <b>next business day</b>. ';
    }

    var html = lead + arrives + ' USPS Ground Advantage.';
    if (note.dataset.rendered !== html) {
      note.innerHTML = html;
      note.dataset.rendered = html;
    }
  }

  /* ---------- enhance loop ---------- */

  function enhance() {
    if (enhancing) return;
    enhancing = true;
    try {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        loadCrossSell(drawer);
        // Cart mutations re-open the drawer (renderContents), so only
        // auto-mutate while the customer is actually in the drawer.
        if (drawer.classList.contains('active')) {
          checkServiceOnly();
          checkEbook();
          checkProtection();
          checkGift();
        }
      }
      updateShipNote();
    } finally {
      enhancing = false;
    }
  }

  var debounceTimer = null;
  function scheduleEnhance() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(enhance, 60);
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(function () {
        if (!enhancing) scheduleEnhance();
      }).observe(drawer, { childList: true, subtree: true });
    }
    enhance();
    setInterval(updateShipNote, 60 * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
